import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageUploaderComponent } from './image-uploader.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconModule } from '../icon/icon.module';
import { InputErrorModule } from '../input-error/input-error.module';

@NgModule({
  declarations: [
    ImageUploaderComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconModule,
    InputErrorModule
  ],
  exports: [
    ImageUploaderComponent
  ]
})
export class ImageUploaderModule { }
